import {
    Paper, BottomNavigation, BottomNavigationAction
} from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import { getTasksRequest } from 'src/store/actions';
import ReportIcon from '@material-ui/icons/Report';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import TodayIcon from '@material-ui/icons/Today';
import { useHistory } from 'react-router';
import icons from 'src/utils/icons';
import TechGpt from './TechGpt';

const BottomRouters = () => {
    const { t } = useTranslation('overview');
    const [value, setValue] = useState(0);
    const history = useHistory();
    const isOnline = useSelector((state) => state.status?.isOnline);


    const menuItems = useSelector((state) => state.testReducer.menu);


    const loadIcon = iconName => {
        const Icon = icons[iconName];
        return Icon ? Icon : null;
    }


    const handleChange = (event, newValue) => {
        setValue(newValue);
        const selectedRoute = menuItems[newValue]?.RouteUrl; // Seçilen elemanın RouteUrl'sini alıyoruz
        if (selectedRoute) {
            history.push(selectedRoute); // RouteUrl'e yönlendiriyoruz
        }
    };

    return (
        <Paper style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={2}>
            <BottomNavigation
                showLabels
                value={value}
                onChange={handleChange}
            >
                {menuItems?.map((item, index) => {
                    const IconComponent = loadIcon(item.IconName);
                    let isDisabled = item.IsDisabledOnOfflineMode && !isOnline;
                    return <BottomNavigationAction style={{
                        color: isDisabled ? 'gray' : 'inherit',
                        opacity: isDisabled ? 0.5 : 1
                    }} disabled={isDisabled} key={index} label={t(item.TranslationKey)} icon={<IconComponent />} />
                }
                )}
            </BottomNavigation>

        </Paper>
    );
};


export default connect(
    (state) => ({ tasks: state.tasks1 }),
    {
        getTasksRequest
    }
)(BottomRouters);
